/* Ziega (bold direction). No dependencies. Rebinds on section reload. */
(function () {
  function initZiega() {
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      /* ---- intro sequence ---- */
      (function () {
        var intro = document.getElementById('zg-intro');
        if (!intro) return;
        var seen = false;
        try { seen = sessionStorage.getItem('zb-intro-seen') === '1'; } catch (err) {}
        if (seen || reduced.matches || window.location.hash) { intro.remove(); return; }
        try { sessionStorage.setItem('zb-intro-seen', '1'); } catch (err) {}
        function finish() { intro.classList.add('zb-is-done'); }
        intro.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
        intro.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
        var timer = setTimeout(finish, 4600);
        intro.addEventListener('click', function () { clearTimeout(timer); finish(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { clearTimeout(timer); finish(); }
        });
      })();

      /* reveal on scroll */
      var items = Array.prototype.slice.call(document.querySelectorAll('.zb-rise'));
      if (reduced.matches || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('zb-in'); });
      } else {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('zb-in');
            io.unobserve(e.target);
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
        items.forEach(function (el) { io.observe(el); });
      }

      /* the ticker needs its content duplicated so the loop is seamless */
      var track = document.getElementById('ticker-track');
      if (track) { track.innerHTML += track.innerHTML; }


      /* ---- horizontal scroll: vertical distance drives sideways travel ---- */
      var hsec = document.querySelector('[data-hsec]');
      var htrack = document.querySelector('[data-htrack]');
      var pin = document.querySelector('[data-pin]');
      var pinImgs = Array.prototype.slice.call(document.querySelectorAll('[data-pin-img]'));
      var pinSlides = Array.prototype.slice.call(document.querySelectorAll('[data-pin-slide]'));
      var pinDots = Array.prototype.slice.call(document.querySelectorAll('.zb-pin-dots i'));
      var wide = window.matchMedia('(min-width: 901px)');

      function structural() {
        if (!wide.matches || reduced.matches) return;

        if (hsec && htrack) {
          var r = hsec.getBoundingClientRect();
          var travel = htrack.scrollWidth - window.innerWidth + 48;
          /* progress through the section's own scroll distance */
          var p = -r.top / (r.height - window.innerHeight);
          p = p < 0 ? 0 : p > 1 ? 1 : p;
          htrack.style.setProperty('--x', Math.round(p * Math.max(travel, 0)));
        }

        if (pin && pinSlides.length) {
          var pr = pin.getBoundingClientRect();
          var pp = -pr.top / (pr.height - window.innerHeight);
          pp = pp < 0 ? 0 : pp > 1 ? 1 : pp;
          var idx = Math.min(pinSlides.length - 1, Math.floor(pp * pinSlides.length));
          pinSlides.forEach(function (el, i) { el.classList.toggle('zb-on', i === idx); });
          pinImgs.forEach(function (el, i) { el.classList.toggle('zb-on', i === idx); });
          pinDots.forEach(function (el, i) { el.classList.toggle('zb-on', i === idx); });
        }
      }

      /* ---- the scrub engine ----
         Every [data-scrub] element gets --p: 0 when its top touches the
         bottom of the viewport, 1 when its bottom passes the top. One
         loop, transforms only, and nothing runs when the page is still. */
      if (!reduced.matches) {
        var scrubbed = Array.prototype.slice.call(document.querySelectorAll('[data-scrub]'));
        var ticking = false;

        function frame() {
          ticking = false;
          var vh = window.innerHeight;
          for (var i = 0; i < scrubbed.length; i++) {
            var el = scrubbed[i];
            var r = el.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) continue;   /* skip far offscreen */
            var span = vh + r.height;
            var p = (vh - r.top) / span;
            el.style.setProperty('--p', (p < 0 ? 0 : p > 1 ? 1 : p).toFixed(4));
          }
          structural();
        }
        function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        frame();
      } else {
        structural();
      }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZiega);
  } else { initZiega(); }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-ziega]')) initZiega();
  });
})();


  /* ---- hero dial cycle: slow cross-fade through the three colours ---- */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      var slides = document.querySelectorAll('.zb-hero-media img');
      if (slides.length < 2) return;
      i = (i + 1) % slides.length;
      for (var k = 0; k < slides.length; k++) {
        slides[k].classList.toggle('zb-on', k === i);
      }
    }, 5200);
  })();
